import React from "react";

export type TDataIconProps = React.SVGAttributes<SVGElement>;

export function DataIcon({ ...rest }: TDataIconProps) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <mask
        id="mask0_2440_1885"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="26"
        height="26"
      >
        <rect width="26" height="26" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2440_1885)">
        <path
          d="M8 18H10V11H8V18ZM12 18H14V8H12V18ZM16 18H18V14H16V18ZM6 22C5.45 22 4.97917 21.8042 4.5875 
            21.4125C4.19583 21.0208 4 20.55 4 20V6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 
            4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V20C22 20.55 21.8042 21.0208 
            21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H6ZM6 20H20V6H6V20Z"
          fill="#00364E"
        />
      </g>
    </svg>
  );
}
